module.exports = __webpack_public_path__ + "static/media/retail.af791249.jpg";